import { getCookie } from "./utils";

const CSRF_TOKEN_COOKIE_NAME = "csrf_token";

export const hasCsrfToken = () => {
  return getCookie(CSRF_TOKEN_COOKIE_NAME) !== null;
};
